<template>
  <header id="headerNavBar" v-if="showNavbar">
    <nav class="navbar navbar-expand-md navbar-dark fixed-top bg-black-header">
      <a class="navbar-brand" href="/#/">
        <img src="static/logo@2x.png" width="124" height="32" />
      </a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mr-auto">
          <!--<li class="nav-item active">
            <a class="nav-link" href="/">Anasayfa <span class="sr-only">(current)</span></a>
          </li>-->
          <li class="nav-item dropdown" v-if="canViewStok || canViewSerials">
            <a class="nav-link dropdown-toggle" href="#" id="dropdown02" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">Stok Yönetimi</a>
            <div class="dropdown-menu" aria-labelledby="dropdown02">
              <a v-if="canViewStok" class="dropdown-item" href="/#/stok">Malzemeler</a>
              <a v-if="canViewSerials" class="dropdown-item" href="/#/stok/seri-numaralar">Seri Numaralar</a>
            </div>
          </li>
          <li class="nav-item dropdown" v-if="canViewProducts">
            <a class="nav-link dropdown-toggle" href="#" id="dropdown03" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">Üretim</a>
            <div class="dropdown-menu" aria-labelledby="dropdown03">
              <a v-if="canViewProducts" class="dropdown-item" href="/#/uretim/urunler">Ürünler</a>
              <a v-if="canViewProducts" class="dropdown-item" href="/#/uretimler">Üretimler</a>
            </div>
          </li>
          <li class="nav-item dropdown" v-if="canViewAriza">
              <a class="nav-link" href="/#/ariza-kayitlari">Arıza Takip</a>
          </li>
          <li class="nav-item dropdown" v-if="canViewSahaOperasyon">
              <a class="nav-link" href="/#/saha-operasyon">Saha - Operasyon</a>
          </li>
          <li class="nav-item dropdown" v-if="canViewUrunCikis">
            <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">Ürün Çıkışları</a>
            <div class="dropdown-menu" aria-labelledby="dropdown01">
              <a class="dropdown-item" href="/#/urun-cikislari">Yeni Ürün Çıkışları</a>
              <a class="dropdown-item" href="/#/eski-urun-cikislari">Eskiden yapılmış çıkışlar</a>
            </div>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link" href="/#/sarf-malzemeleri">Sarf Malzemeleri</a>
          </li>
          <li class="nav-item dropdown" v-if="canUseNotes">
            <a class="nav-link" href="/#/notlar">Notlar</a>
          </li>
          <li class="nav-item dropdown" v-if="canUseNotes">
            <a class="nav-link" href="/#/debug">Test Ekranı</a>
          </li>
        </ul>
        <form class="form-inline mt-2 mt-md-0">
          <div class="btn-group mr-2">
            <button class="btn btn-secondary btn-more-radius"
              data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" type="button">
              &nbsp;&nbsp;{{getPersonelName}}&nbsp;&nbsp;&nbsp;<span class="badge badge-danger">{{notificationCount}}</span>&nbsp;
            </button>
            <div class="dropdown-menu dropdown-menu-large dropdown-menu-right">
              <div class="list-group list-group-flush mb-2">
                <a :href="parseContextLink(notif)" class="list-group-item list-group-item-action" v-for="(notif) in notifications"
                  v-bind:key="'notif-'+notif.NTF_ID">
                  <div class="d-flex w-100 justify-content-between">
                    <h6 class="mb-1">{{parseNotificationType(notif.NTF_CONTEXT_TYPE)}}</h6>
                    <small class="text-muted">{{notif.NTF_CREATED_FORMATTED}}</small>
                  </div>
                  <p class="mb-1">{{notif.NTF_CONTENT}}</p>
                  <!--<small class="text-muted">Tıkla ve detaylara git</small>-->
                </a>
              </div>
              <div class="dropdown-item">
                <a href="/#/logout" class="btn btn-block btn-danger text-center text-white">
                  <i class="fas fa-sign-out-alt text-white"></i>&nbsp;&nbsp;Oturumu Kapat</a>
              </div>
            </div>
          </div>
        </form>
      </div>
    </nav>
  </header>
</template>

<script>
/* eslint-disable */

import axios from 'axios'

export default {
  name: 'Topbar',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      notifyMode: 0, // -1: old but not shown, 0 : all of today, 1: each today, 2: incoming
      showNavbar: false,
      notifications:[],
      notes: [],
      notifyPermissionGranted: false,
      notesNotifierProcessId: 0,
      notifyNoteIndex: 0,
      notificationOptions: {
        title: '',
        body: '',
        icon: '/static/logo@2x.png'
      },
      queryModel: {
        SessionId: '',
        NoteType: -1,
        SearchFilter: ''
      },
    }
  },
  computed: {
    getPersonelName : function() { return this.$store.state.user.personelName },
    getSessionId : function() { return this.$store.getters.getSessionId },
    /* --- */
    canAddAriza : function() { return this.$store.getters.userCanAddAriza },
    canUpdateAriza : function() { return this.$store.getters.userCanUpdateAriza },
    canViewAriza : function() { return this.$store.getters.userCanViewAriza },
    canDeleteAriza : function() { return this.$store.getters.userCanDeleteAriza },
    canAssignTrackingNumber : function() { return this.$store.getters.userCanAssignTrackingNumber },
    /* --- */
    canAddStok : function() { return this.$store.getters.userCanAddStok },
    canSpendStok : function() { return this.$store.getters.userCanSpendStok },
    canViewStok : function() { return this.$store.getters.userCanViewStok },
    canDeleteStok : function() { return this.$store.getters.userCanDeleteStok },
    /* --- */
    canViewProducts : function() { return this.$store.getters.userCanViewProducts},
    canCreateProduct : function() { return this.$store.getters.userCanCreateProduct},
    canDeleteProduct : function() { return this.$store.getters.userCanDeleteProduct},
    canCalculateProduction : function() { return this.$store.getters.userCanCalculateProduction},
    /* --- */
    canViewUrunCikis : function() { return this.$store.getters.userCanViewUrunCikis},
    canInsertUrunCikis : function() { return this.$store.getters.userCanInsertUrunCikis},
    canDeleteUrunCikis : function() { return this.$store.getters.userCanDeleteUrunCikis},
    /* --- */
    canViewSahaOperasyon : function() { return this.$store.getters.userCanViewSahaOperasyon },
    /* --- */
    canViewSerials : function() { return this.$store.getters.userCanViewSerials },
    canAddSerials : function() { return this.$store.getters.userCanAddSerials },
    canUseNotes : function() { return this.$store.getters.userCanUseNotes; },
    /* --- */
    notificationCount: function() { return this.notifications.filter(m => m.NTF_SEEN == "False").length }
  },
  methods: {
    hideOrShowNavbar() {
      console.log(this.$router.history.current["path"])
      if(this.$router.history.current["path"].indexOf('login') > -1)
        return false;
      else return true;
    },
    async getNotes() {
      this.queryModel.SessionId = this.getSessionId
      this.queryModel.NoteType = -1
      this.queryModel.SearchFilter = ""
      axios.post('/api/session/notes', this.queryModel)
      .then(response => {
        let cacheNotes = response.data
        let date = new Date()
        let dayOfWeek = date.getDay() + 1 // Week start number is 1. not 0
        for(let i = 0; i < cacheNotes.length; i++) {
          let noteObj = cacheNotes[i]
          let addNum = noteObj.NOTE_DAYINWEEK - dayOfWeek
          if(noteObj.NOTE_REMINDER_TYPE == 1)
            addNum = addNum < 0 ? addNum + 7 : addNum
          else if(noteObj.NOTE_REMINDER_TYPE == 2)
            addNum = addNum < 0 ? addNum + 30 : addNum

          if(noteObj.NOTE_REMINDER_TYPE == 1 || noteObj.NOTE_REMINDER_TYPE == 2) {
            noteObj.NOTE_DATEDIFF = addNum
            cacheNotes[i] = noteObj
          }
        }
        
        this.notes = cacheNotes
        cacheNotes = null
      })
      .catch(error => { 
        console.error(error) 
      })
    },
    async getNotifications() {
      if(this.getSessionId == null || this.getSessionId == undefined)
        return;

      await axios.post('/api/session/notifications?SessionId=' + this.getSessionId)
      .then(response => this.notifications = response.data)
      .catch(error => {
        console.log('network hatası')
        console.log(error.state)
        console.log(error.message)
      })

      setTimeout(() => { this.getNotifications() }, 60000)
    },
    async getNotesToRemind() {
      let msgBody = ''
      let msgTitle = ''
      let mq = null
      let counterPrice = 0

      if(this.notifyMode == 0 || this.notifyMode == 1)
        mq = this.notes.filter(m => m.NOTE_DATEDIFF == 0 && m.NOTE_STATUS == true)
      else if(this.notifyMode == 2)
        mq = this.notes.filter(m => (m.NOTE_DATEDIFF > 0 && m.NOTE_DATEDIFF < 4) && m.NOTE_STATUS == true)
      else if(this.notifyMode == -1)
        mq = this.notes.filter(m => m.NOTE_DATEDIFF < 0 && m.NOTE_DATEDIFF > -6 && m.NOTE_STATUS == true)
      
      if(mq == null || mq.length == 0) {
        if(this.notifyMode == 2) this.notifyMode == -1
        else this.notifyMode++

        await this.getNotes()
        this.resetReminder()
        return
      }

      if(this.notifyMode == 0) {
        counterPrice = 0
        for(var i = 0; i < mq.length; i++)
          counterPrice += parseInt(mq[i].NOTE_PRICE.trim())

        msgTitle = 'Utku\'dan Notlar'
        msgBody = 'Bugün ' + mq.length + ' farklı kayıt için toplam ' + counterPrice + ' TL ödemeniz var.'

      } else if(this.notifyMode == 1) {
        let ntf_note = mq[this.notifyNoteIndex]
        if(ntf_note != null) {
          msgTitle = ntf_note.NOTE_CAPTION
          if(ntf_note.NOTE_DESCRIPTION != null && ntf_note.NOTE_DESCRIPTION.length > 0) {
            msgBody = ntf_note.NOTE_DESCRIPTION.length > 75 ? ntf_note.NOTE_DESCRIPTION.substring(0, 72) + "..." : ntf.NOTE_DESCRIPTION
          }

          msgBody += '\r\nMiktar ' + parseInt(ntf_note.NOTE_PRICE) + ' TL'
          if(this.notifyNoteIndex == (mq.length -1)) {
            this.notifyNoteIndex == 0
            this.notifyMode = 2
          } else
            this.notifyNoteIndex++
        }

      } else if(this.notifyMode == 2) {
        counterPrice = 0
        for(var i = 0; i < mq.length; i++)
          counterPrice += parseInt(mq[i].NOTE_PRICE.trim())

        msgTitle = 'Utku\'dan Notlar'
        msgBody = 'Önümüzdeki üç gün içinde ' + mq.length + ' farklı kayıt için toplam ' + counterPrice + ' TL ödemeniz var.'
        this.notifyMode = -1

      } else if(this.notifyMode == -1) {
        counterPrice = 0
        for(var i = 0; i < mq.length; i++)
          counterPrice += parseInt(mq[i].NOTE_PRICE.trim())

        msgTitle = 'Utku\'dan Notlar'
        msgBody = 'Geçtiğimiz beş gün içinde tamamlamadığınız ' + mq.length + ' notunuz var.'

        this.notifyMode = 0
        await this.getNotes()
      }

      this.showNotifications(msgTitle, msgBody)
    },
    showNotifications(msgTitle, msgBody) {
      let timeoutVal = 0
      if(this.notifyMode == 0 || this.notifyMode == -1 || this.notifyMode == 2)
        timeoutVal = 60 * 60 * 1000
      else timeoutVal = 20 * 60 * 1000

      clearTimeout(this.notesNotifierProcessId)
      this.notesNotifierProcessId = setTimeout(() => this.getNotesToRemind(), timeoutVal);

      this.notificationOptions.title = msgTitle
      this.notificationOptions.body = msgBody
      var latif = new Notification(msgTitle, this.notificationOptions)
    },
    prepareReminder() {
      if(('Notification' in window) == false){
        console.log('tarayıcınız bildirim alma özelliğini desteklemiyor.')
        return
      }

      if(Notification.permission !== "denied") {
        Notification.requestPermission().then((perm) => {
          if(perm === "granted")
            this.notifyPermissionGranted = true
        })
        return;
      }

      if(Notification.permission === "granted")
        this.notifyPermissionGranted = true
    },
    resetReminder() {
      clearTimeout(this.notesNotifierProcessId)
      this.notesNotifierProcessId = setTimeout(() => this.getNotesToRemind(), 2 * 60 * 1000)
    },
    parseNotificationType(type) {
      if(type == 0)
        return "Ürün çıkışı yapıldı"
     if(type == 3)
        return "Arıza kaydı oluşturuldu"
     if(type == 1)
        return "Yeni mesaj"
    },
    parseContextLink(notif) {
      let pageContext = null
      if(notif.NTF_CONTEXT_TYPE == 0)
        pageContext = "/#/urun-cikislari/contexts/"
      else if(notif.NTF_CONTEXT_TYPE = 1)
        pageContext = "/#/ariza-kayitlari/contexts/"
      else if(notif.NTF_CONTEXT_TYPE == 3)
        pageContext = "/#/ariza-kayitlari/contexts/"

      return pageContext + notif.NTF_CONTEXT_ID
    },
    registerServiceWorker() {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('static/sw.js')
        .then(function() {
            var reg = navigator.serviceWorker.ready
            reg.active.postMessage('test');
        }).then(function(reg) {
            console.log('Service Worker is ready', reg);
            reg.pushManager.subscribe({userVisibleOnly: true}).then(function(sub) {

                console.log('endpoint:', sub.endpoint);
                reg.active.postMessage(JSON.stringify({uid: uid, token: token}));
                console.log("Posted message");

            });
        }).catch(function(error) {
            console.log('Error : ', error);
        });
      }
    }
  },
  watch: {
    $route: function() { 
      this.showNavbar = this.hideOrShowNavbar()
    },
    notifyPermissionGranted: function() {
      if(this.notifyPermissionGranted)
        this.notesNotifierProcessId = setTimeout(() => this.getNotesToRemind(), 9000);
      else
        clearTimeout(this.notesNotifierProcessId)
    }
  },
  mounted() {
    this.showNavbar = this.hideOrShowNavbar()
    //setTimeout(() => this.getNotifications(), 10000)
    //this.prepareReminder()
    //this.getNotes()
    //this.registerServiceWorker()
  }
}
</script>

<style scoped>
  .dropdown-toggle {
    content: '' !important;
  }

  .dropdown-menu-large {
    width: 400px;
  }

  .list-group {
    max-height: 400px !important;
    overflow: auto;
  }

  .list-group-item p {
    font-size: .875rem;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img, .vue-wait-class i {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Topbar.vue